import { SettingsActions } from './actions';

const initialState = {
    categories: [],
    showStatus: false,
}

export const settingsReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SettingsActions.FETCH_CATEGORIES:
            return {
                ...state
            }
        case SettingsActions.FETCH_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: action.payload
            }
        case SettingsActions.FETCH_ATTRIBUTES_SUCCESS:
            return {
                ...state,
                attributes: action.payload
            }
        case SettingsActions.FETCH_CATEGORIES_ERROR:
            console.error('Error fetching categories:', action.payload);
            return {
                ...state,
                error: action.payload
            }
        case SettingsActions.TOGGLE_SHOW_STATUS:
            return {
                ...state,
                showStatus: !state.showStatus
            }
        case SettingsActions.SET_AWESOME_VIEW:
            return {
                ...state,
                awesomeView: action.payload
            }
        case SettingsActions.SET_PROJECTS_TERM:
            return {
                ...state,
                projectsTerm: action.payload
            }
        case SettingsActions.FETCH_PROJECTS:
            return {
                ...state,
                isProjectsSearching: true
            }
        case SettingsActions.FETCH_PROJECTS_SUCCESS:
            return {
                ...state,
                projects: action.payload,
                isProjectsSearching: false
            }
        default:
            return state;
    }
}